<div class="join-workspace h-screen">
  <div class="w-full join-workspace-bg">
    <div class="container mx-auto relative z-10 lg:px-40 pt-12">
      <div class="flex flex-col">
        <div>
          <main class="mt-10 mx-auto max-w-7xl sm:mt-12 md:mt-16 lg:mt-20 xl:mt-20">
            <div class="sm:text-center lg:text-left">
              <h1>
                <span class="block text-slate-500 dark:text-white xl:inline">{{ 'files.join.title' | translate }}</span>
                <span class="block dark:text-gray-400 xl:inline">{{ 'files.join.title_2' | translate }}</span>
              </h1>
              <p class="mt-3 sm:mt-5 sm:max-w-xl sm:mx-auto md:mt-5 lg:mx-0">
                {{ 'files.join.subtitle' | translate }}<strong>{{ owner }}</strong>{{ 'projects.join.subtitle_2' | translate }}<strong>{{ organization }}</strong>.
              </p>
              <div class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <div class="rounded shadow">
                  <a
                    (click)="acceptInvitation()"
                    href="javascript:void(0)"
                    class="join-workspace-btn">
                    <div *ngIf="loading" class="mr-3">
                      <as-spinner></as-spinner>
                    </div>
                    {{ 'files.join.button' | translate }}
                    <span *ngIf="!loading" class="ml-3" aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
              <p class="mt-3 sm:mt-5 sm:max-w-xl sm:mx-auto md:mt-5 lg:mx-0">
                {{ 'projects.join.agreement' | translate }}
              </p>
            </div>
          </main>
        </div>

      </div>
    </div>
  </div>

  <div class="container mx-auto sub-card">
    <div class="w-3/4 mx-auto mt-12">
      <div class="py-12 sm:grid sm:grid-cols-3 sm:gap-4">
        <div>
          <img src="./assets/images/home-1.svg" alt="performance-image" class="w-auto">
        </div>
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <div class="flex flex-row items-center">
            <svg-icon key="outline/light-bubble" class="mr-2"></svg-icon>
            <h1>{{ 'projects.join.panel_title' | translate }}</h1>
          </div>
          <p class="mt-3 sm:mt-5 sm:max-w-xl sm:mx-auto md:mt-5 lg:mx-0">
            {{ 'projects.join.panel_content' | translate }}
            <a href="https://www.quantum-cmms.eu/" target="_blank">
              {{ 'buttons.learn_more' | translate }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
